import { Flex, Box, Image, Button } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../assests/logo.svg";

const Header = () => {
  const [user, updateUser] = useState(null);
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("smart-alim:user"));
    if (token) {
      updateUser(token);
    } else {
      updateUser({});
    }
  }, []);
  return (
    <Flex p="16px">
      {/* ---Logo--- */}

      <Link to="/">
        <Image src={Logo} w="80px" />
      </Link>

      {/* ---White Space--- */}
      <Box flexGrow={1}></Box>

      {/* ---Left Section--- */}
      {/* Display this section only if the user is logged in */}

      {user && Object.keys(user).length > 0 ? (
        <Button
          variant="link"
          onClick={() => {
            localStorage.removeItem("smart-alim:user");
            window.location.href = "/login";
          }}
        >
          Logout
        </Button>
      ) : null}
    </Flex>
  );
};

export default Header;
